import { useRouter } from 'next/router'

export function useUpdateQueryParam() {
  const updateQueryParams = useUpdateQueryParams()
  return function (key: string, value: string | undefined): void {
    return updateQueryParams({ [key]: value })
  }
}

export function useUpdateQueryParams() {
  const router = useRouter()

  return (updatedQueryParams: Record<string, string | undefined>) => {
    const routerQuery: Record<string, string | string[] | undefined> = { ...router.query }
    const searchParams = new URLSearchParams(window.location.search)

    searchParams?.forEach((val, key) => {
      if (typeof val === 'undefined') {
        delete routerQuery[key]
      } else {
        routerQuery[key] = val as string
      }
    })

    Object.entries(updatedQueryParams).forEach(([key, val]) => {
      if (typeof val === 'undefined') {
        delete routerQuery[key]
      } else {
        routerQuery[key] = val as string
      }
    })

    router.replace(
      {
        query: routerQuery,
      },
      undefined,
      { scroll: false, shallow: true }
    )
  }
}
